module.exports = __webpack_public_path__ + "img/848.70cf1439.png";